import { computed, defineComponent } from "vue"; // modules

import AuthModule from "@/store/modules/auth"; // components

import { Navbar, AppMain, Footer } from "./components";
import SalesClosedBanner from "@/views/Booking/components/SalesClosedBanner.vue";
import RefreshApp from "../Booking/components/RefreshApp.vue";
import { Modal } from "@/components/index";
import BookingModule from "@/store/modules/booking";
import UserModule from "@/store/modules/user";
import { isUserLoggedIn } from "@/utils/vue-helpers/user";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import AppModule from "@/store/modules/app";
import Teams from "../Booking/components/Teams.vue";
import { BookingStep } from "@/constants/booking";
import CashFloatModule from "@/store/modules/cash-float";
import DeviceModule from "@/store/modules/device";
import RestoreLogs from "../Booking/components/RestoreLogs.vue";
export default defineComponent({
  name: "Layout",
  components: {
    Modal: Modal,
    Navbar: Navbar,
    AppMain: AppMain,
    Footer: Footer,
    SalesClosedBanner: SalesClosedBanner,
    RefreshApp: RefreshApp,
    Teams: Teams,
    RestoreLogs: RestoreLogs
  },
  setup: function setup() {
    var isAuth = computed(function () {
      return AuthModule.getIsAuth;
    });
    var isLoading = computed(function () {
      return AppModule.isLoading;
    });
    var isRefreshing = computed(function () {
      return AppModule.isRefreshing;
    });
    var isRestoringLogs = computed(function () {
      return AppModule.isRestoringLogs;
    });
    var hasUser = computed(function () {
      return UserModule.hasUser;
    });
    var showTeamsView = computed(function () {
      return isAuth.value && BookingModule.bookingStep === BookingStep.Teams;
    });
    var showCashfloatOpen = computed(function () {
      return !DeviceModule.isOldDeviceLogic && CashFloatModule.isOpeningCashfloat;
    });
    var showCashfloatClose = computed(function () {
      return !DeviceModule.isOldDeviceLogic && CashFloatModule.isClosingCashfloat;
    });
    return {
      hasSalesStarted: hasSalesStarted,
      isUserLoggedIn: isUserLoggedIn,
      isAuth: isAuth,
      isLoading: isLoading,
      hasUser: hasUser,
      isRefreshing: isRefreshing,
      isRestoringLogs: isRestoringLogs,
      showTeamsView: showTeamsView,
      showCashfloatOpen: showCashfloatOpen,
      showCashfloatClose: showCashfloatClose
    };
  }
});